import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import userIcon from '@/assets/icons/user-icon.svg';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/redux/store';
import { userLogout } from '@/redux/reducers/userReducer';


const UserMenu = () => {
  const { isAuthenticated, userName } = useSelector((state: RootState) => state?.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    userLogout(navigate)(dispatch);
  };

  if (!isAuthenticated) {
    return (
      <IconButton color="inherit" component={NavLink} to="/login" aria-label="Log in">
        <img src={userIcon} alt="" style={{ height: 20 }} />
      </IconButton>
    );
  }

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleMenuOpen}
        aria-label="Open user menu"
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl)}
      >
        <img src={userIcon} alt="" style={{ height: 20 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        disableScrollLock
        variant="menu"
      >
        {userName ? <MenuItem disabled>{userName}</MenuItem> : null}
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
